// extracted by mini-css-extract-plugin
export default {"tea-info":"OHTdwo35LDPlpqXS7cZS"};